import { useState } from 'react';
import { GH } from '../theme';

export function GHButton({ children, variant = 'primary', size = 'md', fullWidth, onClick, style: extraStyle = {} }) {
  const [hov, setHov] = useState(false);
  const sizes = { sm: { px: 18, py: 10, fs: 12 }, md: { px: 28, py: 13, fs: 13 }, lg: { px: 36, py: 16, fs: 14 } };
  const s = sizes[size] || sizes.md;
  const variants = {
    primary: { background: hov ? GH.colors.goldDark : GH.colors.gold, color: '#fff', border: 'none' },
    outline: { background: hov ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)', color: '#fff', border: `1.5px solid ${hov ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.4)'}` },
    secondary: { background: 'transparent', color: GH.colors.white, border: `1px solid ${hov ? GH.colors.accent : GH.colors.borderMd}` },
    ghost: { background: 'transparent', color: hov ? GH.colors.gold : GH.colors.greyLight, border: 'none' },
  };
  const v = variants[variant] || variants.primary;
  return (
    <button
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onClick}
      style={{
        ...v,
        fontFamily: GH.fonts.body, fontWeight: 600, fontSize: s.fs,
        letterSpacing: '0.04em', textTransform: 'uppercase',
        padding: `${s.py}px ${s.px}px`,
        cursor: 'pointer', borderRadius: 2,
        transition: 'all 0.2s ease',
        width: fullWidth ? '100%' : 'auto',
        ...extraStyle,
      }}
    >
      {children}
    </button>
  );
}
